const state = {
    id: null,
    entityType: null,
    name: "",
    description: "",
    tags: [],
    currentRequestTemplate: null,
    serverError: null,
    socketError: null,
    lastSavedDate: "",
    createdAt: "",
    createdBy: null,
    lastSavedBy: null,
    inited: false,
    owners: [],
    editable: false,
    inProgress: false,
    tagsSaving: false,
    saved: true,
    hasUnsavedChanges: false,
    isLocked: false,
    restrictions: {},
    duplicating: null,
    isSubscribed: false,
    isSocketStarted: false,
    deleteTarget: null,
    preventNavigation: false,
    dependentCallback: undefined,
    isDependentDialogOpened: false,
    ownershipEditInProgress: false,
    isShareOwnershipDialogOpened: false,
    isRevokeOwnershipDialogOpened: false,
};
export default state;
